import React, { useState, useEffect, useMemo } from 'react'
import moment from 'dayjs'
import { useTranslation } from "@/langs/useTranslation";
import DataTable from '../DataTable'
import TaskStatusBar from '../commons/TaskStatusBar';
import { ReactRender } from "../ReactRender";

const ProfileDeployStatus = ({twinsData, deviceData}) => {
  const [data, setData] = useState({})
  const { t, userLanguage } = useTranslation()
  const statusDes = useMemo(() => {
    return {
      completed: t({defaultMessage: '该功能已成功部署'}),
      failed: t({defaultMessage: '该功能部署失败'}),
      scheduled: t({defaultMessage: '功能部署已准备就绪'}),
      relayed: t({defaultMessage: '功能部署正在等待 Ora 的响应'}),
      queued: t({defaultMessage: '功能部署已收到，即将处理。' }),
      pending: t({defaultMessage: '功能部署已收到，即将处理。' }),
      processing: t({defaultMessage: '功能部署正在进行中。' }),
      onscheduled: t({defaultMessage: '功能部署已安排在选定的发布时间。' }),
      retrying: t({defaultMessage: '功能部署失败，正在重试。' }),
      "": ""
    }
  }, [userLanguage])

  const columns = [
    {
      data: "profileName",
      title: t({ defaultMessage: "配置模板名称" }),
      searchable: false,
      width: "25%"
    },
    {
      data: "version",
      title: t({ defaultMessage: "版本" }),
      searchable: false,
      width: "25%"
    },
    {
      data: "func",
      title: t({ defaultMessage: "功能" }),
      searchable: false,
      width: "15%"
    },
    {
      data: "status",
      title: t({ defaultMessage: "状态" }),
      searchable: false,
      width: "15%",
      createdCell: (td, data, row) => {
        ReactRender((
          <TaskStatusBar
            status={data}
            message={null}
            // isOffline={false}
          />
        ), td);
      }
    },
    {
      data: "report_date",
      title: t({ defaultMessage: "回报时间" }),
      searchable: false,
      width: "20%"
    },
    {
      data: "description",
      title: t({ defaultMessage: "描述" }),
      searchable: false,
    },
  ]
  useEffect(() => {
    if (!twinsData || !deviceData) return

    const { config={} } = twinsData.reported
    if (!config.id && !deviceData.config) return
    let configData
    if (!deviceData.config || config.id === deviceData.config.id) {
      configData = config
    } else {
      configData = deviceData.config
    }

    configData.functions = configData.functions.filter(v => v.status)
    setData(configData.functions.map(v => {
      const status = v.status.toLowerCase()
      return {
        profileName: configData.name,
        func: v.name,
        status: v.status,
        description: status==='failed'? (v.description || statusDes[status]) :(statusDes[status] || ""),
        version: v.version || "",
        report_date: v.report_date? moment(v.report_date).format('YYYY-MM-DD HH:mm'): ""
      }
    }))
  }, [twinsData, deviceData])

  return (
    <DataTable 
      columns={columns}
      data={data}
      // ref={ref}
      ordering={false}
      // scrollable
      // onLoaded={onLoaded}
      autoLoad
      showCheckAll={false}
      paging={false}
      options={{ serverSide: false, paging: false }}
    />
  )
}

export default ProfileDeployStatus